import checkIcon from '../assets/check_mark_yellow.png';
import addiction from '../assets/addiction.png';
import immigrate from '../assets/immigrate.png';
import italy from '../assets/italy.png';
import peace_corps from '../assets/peace_corps.png';
import summer_house from '../assets/summer_house.png';  
import storm from '../assets/storm.png';
import { useEffect } from 'react';

export default function ChooseYourTopic() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="choose-topic-page">
            <div className="choose-topic-container">
                <h2>What Makes a Good Living Legend Topic?</h2>
                <p>Picking a great topic for you Living Legend chapter can make all the difference. Below are some tips for how to think of your story.</p>
                <ul>
                    <li><img src={checkIcon} alt="Checkmark"/> <strong>Clearly Defined</strong><br/>Typically, a good chapter focuses around a distinct period of time, specific set of events, or meaningful experiences. However, broader topics can also work effectively if they have a clear central theme.</li>
                    <li><img src={checkIcon} alt="Checkmark" /> <strong>Full of Stories and Anecdotes</strong><br/> Your topic should easily prompt vivid memories, stories, or emotional moments.</li>
                    <li><img src={checkIcon} alt="Checkmark" /> <strong>Personal</strong><br/> Choose something meaningful, something that is close to you and that you can talk about at length.</li>
                </ul>

                <h3>Examples of Great Living Legend Topics</h3>
                <div className="example-topics-grid">
                    <div className="example-topic-card">
                        <div className="example-topic-icon">
                            <img src={summer_house} alt="Summer house icon" />
                        </div>
                        <div className="example-topic-text">
                            Summers at the lake house
                        </div>
                    </div>
                    
                    <div className="example-topic-card">
                        <div className="example-topic-icon">
                            <img src={italy} alt="Italy icon" />
                        </div>
                        <div className="example-topic-text">
                            Studying abroad in Italy
                        </div>
                    </div>
                    
                    <div className="example-topic-card">
                        <div className="example-topic-icon">
                            <img src={immigrate} alt="Immigration icon" />
                        </div>
                        <div className="example-topic-text">
                            Immigrating to the US
                        </div>
                    </div>
                    
                    <div className="example-topic-card">
                        <div className="example-topic-icon">
                            <img src={addiction} alt="Recovery icon" />
                        </div>
                        <div className="example-topic-text">
                            Overcoming addiction
                        </div>
                    </div>

                    <div className="example-topic-card">
                        <div className="example-topic-icon">
                            <img src={peace_corps} alt="Peace Corps icon" />
                        </div>
                        <div className="example-topic-text">
                            A year in the Peace Corps
                        </div>
                    </div>

                    <div className="example-topic-card">
                        <div className="example-topic-icon">
                            <img src={storm} alt="Recovery icon" />
                        </div>
                        <div className="example-topic-text">
                            Dealing with loss
                        </div>
                    </div>
                </div>

                <h2>Avoid These Common Mistakes</h2>
                <p>To get the most out of your Living Legend chapter, watch out for these common pitfalls:</p>
                <ul className="warning-list">
                    <li><strong>Too Broad</strong>: "My Childhood"
                        <ul className="warning-list-explanation">
                            <li><em>Why?</em> Too expansive to explore deeply in one chapter. Narrow it down to a specific time period, event, or theme.</li>
                            <li className="better-versions"><img src={checkIcon} alt="Checkmark" /> <em>Instead, consider these narrower topics</em><br/>"My Experience in Catholic School" or "Summers at the Lake"</li>
                        </ul>
                    </li>
                    <li><strong>Too Narrow</strong>: "The day my child was born"
                        <ul className="warning-list-explanation">
                            <li><em>Why?</em> Not enough content to create a rich chapter. Consider broadening the topic slightly.</li>
                            <li className="better-versions"><img src={checkIcon} alt="Checkmark" /> <em>Instead, consider these broader topics</em><br/>"Becoming a Parent" or "My First Pregnancy"</li>
                        </ul>                    
                        
                    </li>
                    <li><strong>Too Vague</strong>: "Life Lessons"
                        <ul className="warning-list-explanation">
                            <li><em>Why?</em> Hard to extract detailed stories or clear narratives. Focus instead on specific experiences that influenced these lessons or beliefs.</li>
                            <li className="better-versions"><img src={checkIcon} alt="Checkmark" /> <em>Instead, consider these broader topics</em><br/>"Overcoming an Addiction" or "Going Through a Divorce"</li>
                        </ul>
                    </li>
                </ul>

                <h2>Tips for Picking Your Living Legend Chapter Topic</h2>
                <ul>
                    <li><strong>Think of Stories You Already Love Telling</strong><br/>Chances are that these stories might be part of a larger narrative that could work well as a chapter topic.</li>
                    <li><strong>Reflect on Transformational Moments</strong><br/>Choose experiences or periods that significantly influenced your life or identity.</li>
                    <li><strong>Think About Themes</strong><br/>Chapters can cover longer periods if they have a clear, meaningful theme, such as personal growth, family relationships, or overcoming challenges.</li>
                    <li><strong>Rich in Stories and Anecdotes</strong><br/>The best topics often involve lots of smaller stories and anecdotes.</li>
                </ul>
            </div>
        </div>
    )
}